<!-- All in one line relative in parent -->
<div
  *ngIf="!isCentered; else centeredLoader"
  class="d-inline-flex align-items-end d-print-none mx-3">
  <div
    *ngIf="textOnLeft && text?.length > 0"
    class="mx-2 d-flex flex-column justify-content-end">
    <ng-container *ngIf="size === 'lg'; else smallerHeader">
      <h2
        [class]="color"
        class="mb-0">
        {{ text }}
      </h2>
    </ng-container>
    <ng-template #smallerHeader>
      <h5
        [class]="color"
        class="mb-0">
        {{ text }}
      </h5>
    </ng-template>
  </div>

  <div
    class="custom-spinner negative-margin"
    [class]="size + ' ' + color + ' spinner-' + size + '-' + color"></div>

  <div
    *ngIf="!textOnLeft && text?.length > 0"
    class="mx-2 d-flex flex-column justify-content-end">
    <ng-container *ngIf="size === 'lg'; else smallerHeader">
      <h3
        [class]="color"
        class="mb-0">
        {{ text }}
      </h3>
    </ng-container>
    <ng-template #smallerHeader>
      <h5
        [class]="color"
        class="mb-0">
        {{ text }}
      </h5>
    </ng-template>
  </div>
</div>

<!-- Horizontally centered and in rows -->
<ng-template #centeredLoader>
  <div
    [class]="centeredLoaderClasses()"
    class="d-print-none">
    <div
      class="centered-loader d-flex flex-column align-items-center justify-content-center d-print-none"
      [class]="noContainer ? '' : 'loader-container'">
      <div
        class="custom-spinner mt-5"
        [class]="size + ' ' + color + ' spinner-' + size + '-' + color"></div>

      <div
        *ngIf="text?.length > 0"
        class="text-container mt-5">
        <ng-container *ngIf="size === 'lg'; else smallerHeaderCentered">
          <h2 [class]="color">{{ text }}</h2>
        </ng-container>
        <ng-template #smallerHeaderCentered>
          <h5 [class]="color">{{ text }}</h5>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
